import { useLocalStorageState } from 'ahooks';
import { useCallback } from 'react';

const SPACE_TAB_HISTORY_LS_KEY = 'space-tab-history';

type State = { [k: string]: string };
type Return = {
  value: State;
  setValue: (
    spaceId: number | string,
    spaceTabId: number | string,
    projectId?: number | string,
  ) => void;
};
export const useSpaceTabHistoryLocalStorageState = (): Return => {
  const [state, setState] = useLocalStorageState<State>(
    SPACE_TAB_HISTORY_LS_KEY,
    {},
  );
  const customSetter = useCallback(
    (
      spaceId: number | string,
      spaceTabId: number | string,
      projectId?: number | string,
    ) => {
      const newEntry = {};

      if (projectId) {
        newEntry[projectId] = [spaceId.toString(), spaceTabId.toString()];
      } else {
        newEntry[spaceId] = String(spaceTabId); // fallback
      }

      setState({ ...state, ...newEntry });
    },
    [state, setState],
  );

  return { value: state, setValue: customSetter };
};
